/* eslint-disable */
import type { CMUIServerContext } from '@bingads-webui-campaign-react/server-context';

export interface PageContextValue extends Partial<CMUIServerContext> {
  Culture?: CMUIServerContext['CurrentLocale'];
  CultureDateTimeFormat?: CMUIServerContext['CurrentUser']['CultureDateTimeFormat'];
  [key: string]: unknown;
}

const pageContext: PageContextValue = {
  Culture: window.serverContext && window.serverContext.CurrentLocale,
  CurrentUser: window.serverContext && window.serverContext.CurrentUser
};

export default pageContext;
